"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NonExpiringInMemoryAssignmentCache = void 0;
const abstract_assignment_cache_1 = require("./abstract-assignment-cache");
/**
 * A cache that never expires.
 *
 * The primary use case is for client-side SDKs, where the cache is only used
 * for a single user.
 */
class NonExpiringInMemoryAssignmentCache extends abstract_assignment_cache_1.AbstractAssignmentCache {
    constructor(store = new Map()) {
        super(store);
    }
}
exports.NonExpiringInMemoryAssignmentCache = NonExpiringInMemoryAssignmentCache;
//# sourceMappingURL=non-expiring-in-memory-cache-assignment.js.map